import { useNavigate } from "react-router-dom";
import TableWrapper from "../../../../component/TableWrapper";
import classes from "../../style.module.scss";
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import Button from "../../../../component/Button";

const FirstTimeQRScannedList = (props) => {
    const { metricList, isLoading, sortConfig, setSortConfig, page, setPage, setIsGeneratingPdf, isGeneratingPdf, ListType, setActiveTab, activeTab } = props;
    const navigate = useNavigate();

    const userHeader = [
        { label: "User Name", sortable: "name" },
        { label: "Email", sortable: "email" },
        { label: "Scanned On", sortable: "scannedOn" },
        { label: "Role", sortable: "role" },
        { label: "Scanned Points", sortable: "scannedPoints" },
        { label: "Reference Number", sortable: "referenceNumber" },
    ];

    const handleData = (keyValue, defaultValue = "-", className = "") => {
        return <td className={`${className}`}>{keyValue || defaultValue}</td>;
    };

    const redirectBack = () => {
        navigate('/admin/appAnalytics')
    }

    const generatePdf = () => {
        setIsGeneratingPdf(true)
    }

    return (
        <div className={`eventWrapper`}>
            <div className={`mt-2 mb-5 ${classes.adminTableWrapper}`}>
                <div className={`layout-title flex items-center justify-between mb-6`}>
                    <div className="flex items-center">
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>First Time QR Scanned Users</div>
                    </div>
                    <div className="actions">
                        <Button
                            disabled={isGeneratingPdf}
                            text={"Download"}
                            onClick={generatePdf}
                            style={{
                                lineHeight: "normal",
                                height: "40px",
                                padding: "0px 20px",
                                fontSize: "16px",
                            }}
                        />
                    </div>
                </div>
                <div className={`${classes.userHeaderList} w-[100%] flex items-center cursor-pointer`}>
                    {ListType?.map((title) => <div className={`${classes.userTab} ${activeTab === title ? classes.activeTab : ''}`} onClick={() => setActiveTab(title)}>{title}</div>)}
                </div>

                <TableWrapper
                    headerDetails={userHeader}
                    pageMeta={metricList?.pageMeta}
                    handlePageChange={setPage}
                    listLength={metricList?.result || []}
                    isLoading={isLoading}
                    sortConfig={sortConfig}
                    setSortConfig={setSortConfig}
                >
                    {metricList?.result?.map((item) => {
                        const {
                            id,
                            scanned_date,
                            scanned_points,
                            user,
                            role,
                            product,
                        } = item;

                        // Combine first and last name
                        const userName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
                        const roleName = `${role?.name}`
                        const refNumber = `${product?.reference_number}`


                        const dateConvert = new Date(scanned_date);
                        const monthName = dateConvert.toLocaleString('en-US', { month: 'long' });
                        let date = `${dateConvert.getDate()} ${monthName} ${dateConvert.getFullYear()}`;

                        return (
                            <tr key={id}>
                                {handleData(userName, "-", "text-center")}
                                {handleData(user?.email, "-", "text-center")}
                                {handleData(date, "-", "text-center")}
                                {handleData(roleName, "-", "text-center")}
                                {handleData(scanned_points, "-", "text-center")}
                                {handleData(refNumber, "-", "text-center")}
                            </tr>
                        );
                    })}
                </TableWrapper>
            </div>
        </div>
    );
};

export default FirstTimeQRScannedList;